module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABMAAAATCAMAAABFjsb+AAAAbFBMVEUAAAD///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////8+T+BWAAAAI3RSTlMA/BQKtwUB38/DrKiKgFxED/jz7NfLvY6Me3dsamVPNh2gJUXpL3MAAACjSURBVBjTXY6JDoMgEERXVFBRsd63tvv//9hpqBGckOzwJnuQGQ5yJMdGk+KgvFGcMdekmYPtQmHEzAWJBGWxqErhc0kkOpgZxMbTnRZEZ4u6XlP6X8tHsV3njH7h7eSdANWGXBmGothFOxqhzIFlwKzegFF4oRW/9pQ5Sv+HE3wiYAqYtIJBbB00w3YCoTtmsS21t27DNk26GSV5Jyh66hjMF/ysEQtKNneiAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/guanbi.png
// module id = hPLp
// module chunks = 1